import React, { useState, useEffect } from 'react';
import { Phone, PhoneOff, Video, X, User, Bell } from 'lucide-react';

const IncomingCallToast = ({ onAccept, onReject, callerName }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`fixed top-8 right-8 z-[200] w-full max-w-sm transform transition-all duration-500 ease-out ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-12 opacity-0'}`}>
      <div className="bg-slate-900 rounded-[32px] border border-white/10 shadow-2xl overflow-hidden relative group">
        {/* Animated Background Pulse */}
        <div className="absolute inset-0 bg-indigo-600/10 animate-pulse" />
        
        <div className="p-6 relative z-10">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-500/20 rounded-2xl flex items-center justify-center">
                 <Bell className="w-5 h-5 text-indigo-400 animate-bounce" />
              </div>
              <div>
                <p className="text-[10px] font-black text-indigo-400 uppercase tracking-[0.2em]">Incoming Consultation</p>
                <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-emerald-500 animate-ping" />
                    <p className="text-[11px] font-black text-white/40 uppercase tracking-widest">Secure Link Active</p>
                </div>
              </div>
            </div>
            <button onClick={onReject} className="p-2 hover:bg-white/5 rounded-xl transition-colors text-white/20 hover:text-white">
                <X className="w-5 h-5" />
            </button>
          </div>

          <div className="flex items-center gap-5 mb-8">
             <div className="w-16 h-16 bg-white/5 rounded-[24px] border border-white/10 flex items-center justify-center text-2xl font-black text-white shadow-inner">
                {callerName ? callerName[0].toUpperCase() : 'P'}
             </div>
             <div>
                <h3 className="text-xl font-black text-white tracking-tight">{callerName || 'Patient Guest'}</h3>
                <p className="text-[11px] font-bold text-white/50 mt-1 flex items-center gap-1.5 uppercase tracking-wide">
                    <Video className="w-3.5 h-3.5 text-indigo-500" />
                    Requested Video Call
                </p>
             </div>
          </div>

          <div className="flex gap-3">
             <button 
                onClick={onReject}
                className="flex-1 py-4 bg-white/5 hover:bg-red-500/10 text-white font-black text-[10px] uppercase tracking-widest rounded-2xl border border-white/10 transition-all flex items-center justify-center gap-2 group/btn"
              >
                <PhoneOff className="w-4 h-4 text-red-500 group-hover/btn:scale-110 transition-transform" />
                Decline
             </button>
             <button 
                onClick={onAccept}
                className="flex-[1.5] py-4 bg-emerald-600 hover:bg-emerald-500 text-white font-black text-[10px] uppercase tracking-widest rounded-2xl shadow-xl shadow-emerald-500/20 transition-all flex items-center justify-center gap-2 animate-pulse hover:animate-none scale-105"
              >
                <Phone className="w-4 h-4 animate-bounce" />
                Accept Call
             </button>
          </div>
        </div>

        {/* Bottom Decal */}
        <div className="h-1 bg-gradient-to-r from-transparent via-indigo-500 to-transparent opacity-30" />
      </div>
    </div>
  );
};

export default IncomingCallToast;
